import React, { Fragment } from 'react'
import { Form, Input, Typography } from 'antd'
import PropTypes from 'prop-types'

const pubgMobileLabel = (
  <Typography.Text style={{ fontSize: '18px' }}>
    <span style={{ color: '#d60202' }}>*</span>4. Informe o seu ID Pubg Mobile
    para liberação dos créditos
  </Typography.Text>
)

export const PubgMobile = ({ handleChange, answers }) => {
  return (
    <Fragment>
      <Form.Item name='pubgMobileId' label={pubgMobileLabel}>
        <Input
          type='text'
          name='pubgMobileId'
          value={answers?.pubgMobileId}
          onChange={handleChange('pubgMobileId')}
          required
        />
      </Form.Item>
    </Fragment>
  )
}

PubgMobile.propTypes = {
  handleChange: PropTypes.func,
  answers: PropTypes.any,
}
